const SET_LISTA = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.lista.data = payload
    state.lista.lastUpdate = new Date()
  }
}

const SET_LISTA_LOADING = (state, payload) => {
  state.lista.loading = payload
}

export { SET_LISTA, SET_LISTA_LOADING }
